<label>
  <span class="fw-semibold">
    {{ label }}
  </span>
</label>
<form [formGroup]="itemsGroup" class="mt-3">
  <fieldset>
    <div class="d-flex align-items-center select-all">
      <div class="form-check me-5" id="select-all-checkbox">
        <input (click)="onSelectAllCheckboxChange($event)"
          [checked]="selectAllChecked"
          [id]="'select-all-checkbox-' + section"
          [indeterminate]="selectAllIndeterminate"
          class="form-check-input"
          [disabled]="(deploymentService.isDeploymentAllowedForSelectedEntity$ | async) === false"
          type="checkbox"
          value=""/>
          <label [for]="'select-all-checkbox-' + section" class="form-check-label">
            {{deploymentLevel.selectAllLabel}}
          </label>
        </div>
            <div [ngbTooltip]="{
                     output: 'Select the ' + (deploymentLevel.labelInPlural | lowercase) + ' to be changed',
                     condition: itemsList.length === 0,
                     alternative: {
                        condition: (deploymentService.isChangeConfigurationAvailable$ | async) === false,
                        output: 'Select only  ' + (deploymentLevel.labelInPlural | lowercase) + '  that are deployed'
                     }
                 } | showCase"
        class=" ms-auto"
        placement="bottom auto">
        @if (editConfiguration && isConfigurationAvailable &&
          ((PermissionsType.MANAGE_MARKET_CATALOG | hasPermission:entitySelected.label)
          || (PermissionsType.MANAGE_SCRIPT_CONFIGURATION | hasPermission))) {
          <button (click)="triggerEditConfiguration()"
            [disabled]="(deploymentService.isChangeConfigurationAvailable$ | async) === false"
            class="btn btn-outline-primary df-btn-tertiary"
            id="change-script-config-btn">Change configuration
          </button>
        }
      </div>
    </div>
    <hr class="my-2"/>
    <div class="items">
      @if (itemsList.length === 0) {
        <span
        >No result found</span>
      } @else {
        <cdk-virtual-scroll-viewport class="h-100" itemSize="10">
          <div *cdkVirtualFor="let item of itemsList; let index = index"
            class="hover-marked py-2 ps-2">
            <div class="form-check">
              <input (click)="onSelectItemCheckboxChange(item)"
                [formControl]="(itemsGroup.get('checkboxArray')!) | extractFormAtIndex: index"
                [id]="'item-' + section + index"
                class="form-check-input"
                type="checkbox"
                value=""/>
                <label [for]="'item-' + section + index"
                  class="form-check-label w-100 me-0 text-nowrap hidden-ellipsis">
                  <span class="me-3">{{ item.itemName }}</span>
                  @if (item.tag) {
                    @if (item.tag === 'warning') {
                      <span
                        class="fa-exclamation-triangle fa-solid text-gray-600">
                      </span>
                    }
                    @if (item.tag !== 'warning') {
                      <span
                        class="me-2 badge rounded-pill bg-secondary text-white no-text-transform">
                        {{ item.tag }}
                      </span>
                    }
                  }
                  <span [title]="item.configurationsTooltip | filterItemsLabel"
                    class="text-gray-600 fst-italic text-decoration-underline"
                    id="deployed-config-description-{{index}}">
                    {{ item.configurations | filterItemsLabel }}
                  </span>
                </label>
              </div>
            </div>
          </cdk-virtual-scroll-viewport>
        }
      </div>
      <hr class="my-2"/>
    </fieldset>
  </form>
